
import { Component, Vue, Prop } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator, phoneNumberValidator, usernameValidator, nameValidator } from '../../utils/validator'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
@Component({
  components: {},
})
export default class DisplayImage extends Vue {
  private showDialog: boolean = false
  private imageUrl: string = ''
  public show(imageUrl: string) {
    this.imageUrl = imageUrl
    this.showDialog = true
  }
  public cancel() {
    this.showDialog = false
  }
}
